/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";

import { bem } from "../shared/BEM";
import { IModelListEntry, ModelList } from "./ModelList";
import { ModelProvider } from "../providers/ModelProvider";

/**
 * Component props
 */
export interface IMainSidebarProps {
	modelProvider: ModelProvider;
	opened?: boolean;
}

/**
 * Main sidebar component
 *
 * @param props Props
 */
export function MainSidebar(props: IMainSidebarProps) {

	const getModels = (search: string) : Array<IModelListEntry> => {

		return props.modelProvider.getList(search).map((item) => ({
			route: "/models/" + item.id,
			icon: item.icon,
			title: item.title,
			description: item.description,
			version: item.version
		}));

	};

	const [searchValue, setSearchValue] = useState("");
	const [items, setItems] = useState(getModels(searchValue));

	const handleSearch = (ev) => {

		setSearchValue(ev.target.value);
		setItems(getModels(ev.target.value));

	};

	const mods = [];

	if (props.opened) {
		mods.push("opened");
	}

	const style = bem("main-sidebar", "", mods);

	return <div className={style.className()}>
		<header className={style.el("header").className()}>
			<div className={style.el("logo").className()}>
				<img src="/assets/logo-vste.png" alt="VŠTE" />
				<h1>Projektové a inovační centrum</h1>
			</div>
			<h2 className={style.el("title").className()}>Malé a střední podniky ve venkovském prostoru</h2>
			<input
				className={style.el("search-box").className()}
				type="text"
				placeholder="Vyhledat modely..."
				value={searchValue}
				onChange={handleSearch}
			/>
		</header>
		<ModelList models={items} />
	</div>;

}
